<template>
  <b-col sm="12" :lg="size" :offset="offset">
    <DateModal
      v-if="chartType != 'Shipped' && chartType != 'Received'"
      :modalID="chartType"
      :fetchData="fetchData"
      :dateFrom="dateFrom"
      :dateTo="dateTo"
      @date-picker-modal-emit="onDatePickerModalEmit"
    ></DateModal>
    <DateProductManufacturerModal
      v-if="chartType === 'Shipped' || chartType === 'Received'"
      :modalID="chartType"
      :fetchData="fetchData"
      :dateFrom="dateFrom"
      :dateTo="dateTo"
      @date-picker-modal-emit="onDateProductPickerModalEmit"
    ></DateProductManufacturerModal>
    <b-card class="backClass" style="min-height: 587px">
      <div
        slot="header"
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <HeaderTitle
          :title="title"
          :dateFrom="from ? from : dateFrom"
          :dateTo="to ? to : dateTo"
        ></HeaderTitle>
        <HeaderControl
          :showFullscreenIcon="true"
          :showDateIcon="true"
          :showDownloadPdfIcon="true"
          :showDownloadExcelIcon="chartType !== 'company'"
          @emit-fullscreen="toggleFullScreen"
          @emit-date="modalDateEvent(chartType)"
          @emit-pdf-download="downloadPDF"
          @emit-excel-download="downloadExcel"
        ></HeaderControl>
      </div>
      <div
        style="width: 100%; display: flex; justify-content: flex-end"
        v-if="withFinancial"
      >
        <h5>Quantity</h5>
        <c-switch
          class="mx-1"
          color="primary"
          v-model="valueQuantity"
          value="true"
          uncheckedValue="false"
          variant="pill"
        />
        <h5>Financials</h5>
      </div>
      <div class="chart-wrapper">
        <div v-if="loadingData" class="centered_container">
          <LoadingCard></LoadingCard>
        </div>
        <highcharts
          ref="backRef"
          v-else
          :options="chartOptions"
          class="chart"
          :constructor-type="'chart'"
        />
      </div>
      <div slot="footer">
        <b-button
          :disabled="!showAll"
          class="btn-outline"
          variant="outline-primary"
          left
          @click="(showAll = false), fetchData()"
          >Top 10</b-button
        >
        <b-button
          :disabled="showAll"
          class="btn-outline float-right"
          variant="outline-primary"
          right
          @click="(showAll = true), fetchData()"
          >All Data</b-button
        >
        <b-button
          v-if="chartType === 'Shipped' || chartType === 'backlog' || chartType === 'projects' || chartType === 'Received'"
          class="btn-outline float-right"
          style="margin-right: 10px"
          variant="outline-primary"
          right
          @click="showTableAll()"
          >Table View All Data</b-button
        >
        <b-button
          v-if="chartType === 'Received'"
          class="btn-outline float-right"
          style="margin-right: 10px"
          variant="outline-primary"
          :disabled="loadingSummaryReport"
          @click="downloadClientSummaryReport"
          >Client Summary Report</b-button
        >
      </div>
    </b-card>
  </b-col>
</template>

<script>
import { Switch as cSwitch } from "@coreui/vue";
import Highcharts from "highcharts";
import { Chart } from "highcharts-vue";
import exporting from "highcharts/modules/exporting";
import Datepicker from "vuejs-datepicker";
import DateModal from "../shared/DateModal.vue";
import DateProductManufacturerModal from "../shared/DateProductManufacturerModal.vue";
import HeaderControl from "../shared/HeaderControl.vue";
import HeaderTitle from "../shared/HeaderTitle.vue";
import LoadingCard from "../shared/LoadingCard.vue";
import { chartFunctionsMixin } from "./addons/chartFunctionsMixin.js";
import { chartOptionsMixin } from "./addons/chartOptionsMixin.js";
exporting(Highcharts);

export default {
  mixins: [chartFunctionsMixin, chartOptionsMixin],
  components: {
    highcharts: Chart,
    Highcharts,
    Datepicker,
    cSwitch,
    DateModal,
    DateProductManufacturerModal,
    LoadingCard,
    HeaderTitle,
    HeaderControl,
  },
  props: [
    "size",
    "offset",
    "title",
    "withDate",
    "withFinancial",
    "chart",
    "chartType",
    "isCompanyOverall",
    "isCompanyProfile",
    "company",
    "city",
    "cityName",
    "model",
    "modelName",
  ],
  data: () => {
    return {
      dateFrom: "",
      dateTo: "",
      selectedProduct: "",
      selectedManufacturer: "",
      loadingSummaryReport: false,
    };
  },
  methods: {
    downloadClientSummaryReport() {
      this.loadingSummaryReport = true;
      const params = {
        date_from: this.from,
        date_to: this.to,
        productModel: this.selectedProduct
          ? this.selectedProduct.map(product => product.id).join(",")
          : "",
        customer: this.selectedManufacturer
          ? this.selectedManufacturer.map(customer => customer.id).join(",")
          : "",
      };

      this.$http.get("api/teleste/tables/client_summary_report.php", {
        params,
        responseType: "blob",
      }).then(res => {
        const url = window.URL.createObjectURL(res.data);
        const link = document.createElement("a");
        link.href = url;
        link.download = "ClientSummaryReport.xlsx";
        document.body.appendChild(link);
        link.click();
        link.remove();
        setTimeout(() => window.URL.revokeObjectURL(url), 1000);
      }).catch(err => {
        console.error("Unable to download client summary report:", err);
      }).finally(() => {
        this.loadingSummaryReport = false;
      });
    },
    showTableAll() {
      this.$router.push(
        "/base/Tables/?type=" +
          this.chartType +
          "&date_from=" +
          this.dateFrom +
          "&date_to=" +
          this.dateTo +
          (this.selectedProduct && this.selectedProduct.length
            ? "&productModel=" + this.selectedProduct.map(product => product.id).join(',')
            : "") +
          (this.selectedManufacturer
            ? "&customer=" + this.selectedManufacturer.map(manufacturer => manufacturer.id).join(',')
            : "")
      );
    },
     downloadExcel() {
      this.loading2019 = true;
      let params = {};
      params = {
        date_from: this.dateFrom,
        date_to: this.dateTo,
        company: this.company ? this.company : "",
        client: this.city,
        model: this.model,
        productModel: this.selectedProduct ? this.selectedProduct.map(product => product.id).join(',') : "",
        customer: this.selectedManufacturer ? this.selectedManufacturer.map(manufacturer => manufacturer.id).join(',') : "",
        xml: "true",
      };

    if (this.chartType === "Received") {
      this.excelDownload = "api/teleste/tables/received.php";
    }
    if (this.chartType === "Shipped"|| this.chartType==='shipped') {
        this.excelDownload = "api/teleste/tables/shipped.php";
    }
    if (this.chartType === "top") {
      this.excelDownload = "api/teleste/tables/shipped.php";
    }
    if (this.chartType === "OEM") {
      this.excelDownload = "api/teleste/tables/oem_backlog.php";
    }
    if (this.chartType === "OEMShip") {
      this.excelDownload = "api/teleste/tables/oem_delivered.php";
    }
    if (this.chartType === "ber"|| this.chartType=== 'BER') {
      this.excelDownload = "api/teleste/tables/ber.php";
    }
    if (this.chartType === "eol" || this.chartType=== 'EOL') {
      this.excelDownload = "api/teleste/tables/eol.php";
    }
    if (this.chartType === "ntf") {
      this.excelDownload = "api/teleste/tables/ntf.php";
    }
    if (this.chartType === "war") {
      this.excelDownload = "api/teleste/tables/war.php";
    }
    if (this.chartType === "backlog") {
        this.excelDownload = "api/teleste/tables/back.php";
    }
    if (this.chartType === "projects") {
      this.excelDownload = "api/teleste/tables/projects.php";
    }
    if (this.chartType === "city") {
      this.excelDownload = "api/teleste/tables/shipped.php";
    }
    if (this.chartType === "SubDivisionBacklog") {
      this.excelDownload = "api/teleste/tables/subdivision_backlog.php";
    }
    if (this.chartType === "SubDivisionDelivered") {
      this.excelDownload = "api/teleste/tables/subdivision_delivered.php";
    }
    if (this.chartType === "company") {
      this.excelDownload = "api/teleste/company/table.php";
    }
    

      this.$http
        .get(this.excelDownload, {
          params,
          responseType: "blob"
        })
        .then(
          res => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "TableReport.xlsx");
            document.body.appendChild(link);
            link.click();
            this.loading2019 = false;
          },
          err => {
            this.loading2019 = false;
            console.log(err);
          }
        );
    },
    onDateProductPickerModalEmit(
      changedDateFrom,
      changedDateTo,
      product,
      manufacturer
    ) {
      this.dateFrom = changedDateFrom;
      this.dateTo = changedDateTo;
      this.selectedProduct = product;
      this.selectedManufacturer = manufacturer;
    },
    fetchData() {
      this.loadingData = true;

      let finType = "Fin";
      if (!this.valueQuantity || this.valueQuantity == "false") {
        finType = "Qty";
      }
      let params = {};
      let link = null;
      if (this.isCompanyOverall) {
        link = `${process.env.VUE_APP_TRACKER_BASE}/api/teleste/company/chart_all.php`;
      } else if (this.isCompanyProfile) {
        link = `${process.env.VUE_APP_TRACKER_BASE}/api/teleste/company/chart_profile.php`;
      } else if (this.city) {
        link = `${process.env.VUE_APP_TRACKER_BASE}/api/teleste/charts/chart_city.php`;
      } else if (this.model) {
        link = `${process.env.VUE_APP_TRACKER_BASE}/api/teleste/charts/chart_product.php`;
      } else {
        link = `${process.env.VUE_APP_TRACKER_BASE}/api/teleste/charts/chart_data.php`;
      }

      params = {
        type: finType,
        date_from: this.from,
        date_to: this.to,
        chartType: this.chartType,
        company: this.company ? this.company : "",
        client: this.city,
        model: this.model,
        productModel: this.selectedProduct ? this.selectedProduct.map(product => product.id).join(',') : "",
        customer: this.selectedManufacturer ? this.selectedManufacturer.map(manufacturer => manufacturer.id).join(',') : "",
      };

      this.$http.get(link, { params }).then(
        (res) => {
          if (
            res.data &&
            (res.data.upData || res.data.dnData || res.data.totals)
          ) {
            let tmp = res.data.upData;
            tmp &&
              tmp.length > 0 &&
              tmp.sort((a, b) =>
                parseFloat(a.locationTotal) > parseFloat(b.locationTotal)
                  ? -1
                  : 1
              );

            let smp = res.data.dnData;
            smp && smp.length > 0
              ? smp.forEach((value) => {
                  value.data.sort((a, b) =>
                    parseInt(a[1]) > parseInt(b[1]) ? -1 : 1
                  );
                })
              : "";
            if (tmp && tmp.length > 0)
              if (!this.showAll) {
                this.chartOptions.series[0].data = tmp.slice(0, 10);
              } else {
                this.chartOptions.series[0].data = tmp;
              }
            if (!this.isCompanyProfile) {
              this.chartOptions.drilldown.series = smp;
            }
            if (this.isCompanyOverall) {
              this.chartOptions.drilldown.series = null;
            }
            if (this.isCompanyProfile) {
              this.chartOptions.drilldown.series = null;
            }
            if (this.model) {
              this.chartOptions.drilldown.series = null;
            }

            if (finType == "Fin") {
              this.chartOptions.title.text =
                "Total : $" +
                res.data.totals
                  .toFixed(2)
                  .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
            } else {
              this.chartOptions.title.text = "Total units: " + res.data.totals;
            }

            this.loadingData = false;
            setTimeout(() => {
              this.changeHeight();
            });
          } else {
            this.loadingData = false;
          }
        },
        (err) => {
          this.loadingData = false;
          console.log(err);
        }
      );
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.highcharts-exporting-group {
  display: none !important;
}
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #515b65 !important;
  opacity: 1 !important;
}
.centered_container {
  width: 100%;
  display: flex;
  justify-content: center;
}
/* Uniform icon button sizing and spacing */
.card-header-actions {
  display: flex;
  align-items: center;
  gap: 4px;
}
.card-header-actions .btn {
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  font-size: 14px;
}
.card-header-actions .fa-file-excel-o {
  transform: none !important;
}
</style>
